import React from 'react';
import styled from 'styled-components';
import {useParams} from 'react-router-dom';
import {useAutomaticMailSendsByWorkflowQuery} from 'api';
import {useTable} from 'react-table';
import Cell from './Cell';
import {Pagination as UIPagination} from 'components/antd';
import useSearchParams from './useSearchParams';

const PER_PAGE = 20;

export default () => {
  const [page, setPage] = React.useState(1);
  const {query} = useSearchParams();
  const {workflowId} = useParams<{workflowId: string}>();
  const {
    data: {
      automaticMailSendsByWorkflow: {
        automaticMailSends = [],
        pagination = {},
      } = {},
    } = {},
  } = useAutomaticMailSendsByWorkflowQuery({
    variables: {
      uuid: workflowId,
      page,
      perPage: PER_PAGE,
      status: query.status,
    },
    fetchPolicy: 'cache-and-network',
  });

  const columns: any = React.useMemo(
    () => [
      {
        id: 'status',
        Header: 'ステータス',
        Cell: Cell.Status,
        style: {
          width: '80px',
        },
      },
      {
        id: 'prospectEmail',
        Header: 'メールアドレス',
        Cell: Cell.ProspectEmail,
      },
      {
        id: 'prospectName',
        Header: 'リード名',
        Cell: Cell.ProspectName,
      },
      {
        id: 'accountName',
        Header: '企業名',
        Cell: Cell.AccountName,
      },
      {
        id: 'sendAt',
        Header: '送信日時',
        Cell: Cell.SendAt,
      },
      {
        id: 'step',
        Header: 'ステップ',
        Cell: Cell.Step,
      },
    ],
    [],
  );

  const {getTableProps, getTableBodyProps, headerGroups, rows, prepareRow} =
    useTable({columns, data: automaticMailSends});

  return (
    <Container>
      <ContentsTable {...getTableProps()} cellSpacing="0" cellPadding="0">
        <thead>
          {headerGroups.map((headerGroup, i) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={i}>
              {headerGroup.headers.map((column, j) => {
                return (
                  <th
                    {...column.getHeaderProps([
                      {
                        // @ts-ignore
                        style: column.style,
                      },
                    ])}
                    key={j}>
                    {column.render('Header')}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} key={i}>
                {row.cells.map((cell, j) => {
                  return (
                    <td {...cell.getCellProps()} key={j}>
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </ContentsTable>
      <Pagination
        size="small"
        showSizeChanger={false}
        showQuickJumper={false}
        total={pagination.totalCount}
        current={pagination.currentPage}
        pageSize={PER_PAGE}
        onChange={(page) => setPage(page)}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ContentsTable = styled.table`
  width: 100%;
  border-collapse: separate; /* Don't collapse */
  border-spacing: 0;
  table-layout: fixed;

  td {
    min-width: 50px;
    padding: 0.5rem 1rem;
    margin: 0px;

    &:first-child {
      padding-left: 0;
    }
  }

  thead {
    tr {
      th {
        padding: 8px 1rem;
        font-size: 12px;
        color: var(--text-color-2);
        text-align: left;
        border-bottom: solid 1px #e1e6eb;

        &:first-child {
          padding: 3px 1rem 3px 0;
        }
      }
    }
  }

  tbody {
    font-size: 14px;

    tr {
      box-sizing: border-box;
      background: #fff;

      td {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        border-bottom: solid 1px #e1e6eb;
      }
    }
  }
`;

const Pagination = styled(UIPagination)`
  display: inline-block;
  padding: 20px 0;
  height: 65px;
  border-radius: 5px;

  li {
    width: 30px !important;
    height: 30px !important;

    a {
      width: 100%;
      height: 100%;
      line-height: 30px;
    }

    svg {
      width: 10px;
      height: 10px;
    }
  }

  .ant-pagination-item-active {
    border: none;
    background: none;

    a {
      color: var(--text-color-1);
      background: var(--border-color);
      border-radius: 100px;
    }
  }
`;
